import { useFetch } from '@/shared/hooks/useFetch';
import { useMutate } from '@/shared/hooks/useMutate';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiClientBlockParcelCreation,
  apiClientClaimedTrekIdsGet,
  apiClientGet,
  apiClientReceiptsGet,
  apiClientsGet,
  apiClientUnblockParcelCreation,
} from '@/entities/client/modules/api/clients';
import type { ApiClientsListParams } from '@/shared/types/api/clients';

export const useClientsList = (params: ApiClientsListParams) =>
  useFetch({
    api: () => apiClientsGet(params),
    keywords: queryKeys.clients.list(params),
    staleTime: 60_000,
  });

export const useClientDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiClientGet(id ?? ''),
    keywords: queryKeys.clients.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });

export const useClientClaimedTrekIds = (id: string | undefined) =>
  useFetch({
    api: () => apiClientClaimedTrekIdsGet(id ?? ''),
    keywords: queryKeys.clients.claimedTrekIds(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });

export const useClientReceipts = (userId: string | undefined) =>
  useFetch({
    api: () => apiClientReceiptsGet(userId ?? ''),
    keywords: queryKeys.clients.receipts(userId ?? ''),
    enabled: Boolean(userId),
    staleTime: 30_000,
  });

export const useClientBlockParcelCreation = (id: string | undefined) =>
  useMutate({
    api: () => apiClientBlockParcelCreation(id ?? ''),
    invalidateKeys: [queryKeys.clients.all],
  });

export const useClientUnblockParcelCreation = (id: string | undefined) =>
  useMutate({
    api: () => apiClientUnblockParcelCreation(id ?? ''),
    invalidateKeys: [queryKeys.clients.all],
  });
